import React from "react";
import Grid from "@mui/material/Grid";
import Profile from "../../../../assets/images/user1.png";
import Avatar from "@mui/material/Avatar";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { style } from "./style";
import { Download } from "@mui/icons-material";
import { ReactComponent as Sheet } from "../../../../assets/ViewLeave-images/material-symbols_receipt-outline.svg";
import { ReactComponent as Calender } from "../../../../assets/ViewLeave-images/Vector (1).svg";
import { ReactComponent as Hastag } from "../../../../assets/ViewLeave-images/ph_hash-bold.svg";
import { ReactComponent as Info } from "../../../../assets/ViewLeave-images/material-symbols_info-outline.svg";
import { ReactComponent as Reason } from "../../../../assets/ViewLeave-images/Vector.svg";
import { formatDate } from "../../../../utils/DateFormat";
import dayjs from "dayjs";

const ViewLeaveManagementPage = ({ item, handleRequest, leave, handleDownload }) => {
  const permissionObj = localStorage.getItem("permission");
  const permission = JSON.parse(permissionObj)
  const permissionEdit = permission?.leave?.isEdit;
  return (
    <>
      <Button type="button" onClick={handleDownload} sx={style.exportBtn}>
        <Download />
        Export Pdf
      </Button>
      <Grid container sx={{ display: "flex", p: "25px", justifyContent: "space-between" }}>
        <Grid item xs={12} lg={7.4} sx={style.gridbioBox}>
          <Box sx={style.upperContainer}>
            <Box sx={style.profileBox}>
              <Box>
                <Avatar alt="profile" src={item?.image} sx={style.avatar} />
              </Box>
              <Box>
                <Typography variant="h4" sx={style.employeeName}>{item?.fullName}</Typography>
                <Typography variant="p" sx={style.textPrimary}>{item?.employee?.personalInfo?.jobPosition?.[0] || item?.employee?.personalInfo?.jobPosition || "Employee"}</Typography>
                <Typography variant="body1" sx={style.employeeId}>{`Employee ID: ${item?.employee?.stafId || "-"}`}</Typography>
              </Box>
            </Box>
            {/* <Box sx={style.actionContainer}>
              {permissionEdit ?
                <Box sx={style.btnSection}>
                  {item?.status === "Pending" ? (
                    <>
                      <Button type="button" onClick={() => handleRequest(item?._id, "Rejected")} sx={style.rejectBtn} >{"Reject"}</Button>
                      <Button type="button" onClick={() => handleRequest(item?._id, "Approved")} sx={style.successBtn} >{"Approve"}</Button>
                    </>
                  ) : item?.status === "Approved" ? (
                    <>
                      <Button type="button" onClick={() => handleRequest(item?._id, "Rejected")} sx={style.rejectBtn} >{"Reject"}</Button>
                    </>
                  ) : item?.status === "Rejected" ? (
                    <>
                      <Button type="button" onClick={() => handleRequest(item?._id, "Approved")} sx={style.successBtn} >{"Approve"}</Button>
                    </>
                  ) : null}
                </Box> : null}
            </Box> */}
          </Box>
          <Box sx={style.infooBox}>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Sheet />
                <Typography variant="body1" sx={style.bioIconText}>
                  Leave Type
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.leaveType}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Calender />
                <Typography variant="body1" sx={style.bioIconText}>
                  Leave From
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.leaveFrom}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Calender />
                <Typography variant="body1" sx={style.bioIconText}>
                  Leave To
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.leaveTo}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Hastag />

                <Typography variant="body1" sx={style.bioIconText}>
                  Number of Days
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.noOfDays}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Calender />

                <Typography variant="body1" sx={style.bioIconText}>
                  Date Of Request
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.dateReq}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Info />

                <Typography variant="body1" sx={style.bioIconText}>
                  Status
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.status}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Reason />

                <Typography variant="body1" sx={style.bioIconText}>
                  Reason
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.reason}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} lg={4.3} sx={{ mt: { xs: 3, lg: 0 } }}>
          <Grid sx={style.gridInfoBox}>
            <Typography sx={style.boxHeading}>Total Leave Balance</Typography>
            <Box sx={style.infoBox}>

              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  Available balance
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  Currently booked
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  Balance after booked leave
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  {leave?.totalLeaveBalance?.remainingLeaveBalance}
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  {leave?.totalLeaveBalance?.currentlyBooked}
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  {leave?.totalLeaveBalance?.balanceAfterBookedLeave}
                </Typography>
              </Box>

            </Box>
          </Grid>
          <Grid sx={style.gridInfoBox}>
            <Typography sx={style.boxHeading}>Leave This Month</Typography>
            <Box sx={style.infoBox}>

              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  Total applied
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  Approved leaves
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  Rejected leaves
                </Typography>
              </Box>
              <Box>
                <Typography sx={style.bioText}>
                  {leave?.leavesByMonth?.totalApplied}
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  {leave?.leavesByMonth?.approvedLeaves}

                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  {leave?.leavesByMonth?.rejectedLeaves}

                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid >


    </>
  )
}
export default ViewLeaveManagementPage;
